import { ZfBox, ZfStack } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { Info } from './Info';
import { PrimaryNavigation } from './PrimaryNavigation';

export const UserToolbar: FunctionComponent = () => (
    <ZfBox className="app-toolbar toolbar" style={{ position: 'fixed', zIndex: 1200, top: 0, left: 0, right: 0 }}>
        <ZfStack direction="row" alignment="center" className="toolbar__navigation toolbar__navigation--standalone" style={{ minHeight: '64px' }}>
            <Info />
            <PrimaryNavigation />
        </ZfStack>
    </ZfBox>
);
